
import React from "react";
import { convertAdUrl, translateText } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Translate from "../MultiLanguage/Translate"

const AgeVerifyModal = ({setShowAgeVerifyModal}) => {

 const confirmHandler = () => {
    localStorage.setItem("ageVerified", "true");
    setShowAgeVerifyModal(false);
  };

  return (
    <div className="ageVerifyContainer">
      <div className="overlayModal"></div>
      <div className="contents">
        <h1> To continue, please confirm that you are 18 years of age or older.</h1>
        <h3>This website contains sensitive content and is strictly intended for adult viewers only.</h3>
        <div className="buttons">
          <div
            className="buttonContainer"
            onClick={confirmHandler}
          >
            <div className="background"></div>
            <button><Translate textKey={'yes'} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeVerifyModal;


